import React, { useEffect, useState } from 'react';

import { Modal } from '../../../../components';

import {
  OkeyBtn,
} from './Styles';
import { Ads3pdVO } from '../../../../lib/types';
import RowCenter from '../../../../components/Layout/RowCenter';
import ColumnCenter from '../../../../components/Layout/ColumnCenter';
import SquadRegularText from '../../../../components/Text/SquadRegularText';
import { getRandomIntInRange, getWindowHeight, getWindowWidth } from '../../../../lib/utils/utils';
import SquadBoldText from '../../../../components/Text/SquadBoldText';
import RowEnd from '../../../../components/Layout/RowEnd';
import { addFoodifoxLog } from '../../../../lib/axios/FoodifoxDataAPI';
import Loading from '../../../../components/Loading';

const AdsModal: React.FC<Props> = ({
  onClose,
  isEnglish,
  adsList,
  showAdsSeconds,
  deviceCode,
  phoneNumber,
  skipAdsSeconds,
}) => {
  const contentRef = React.useRef<HTMLDivElement>(null);
  const [mediaUrl, setMediaUrl] = useState<string>();
  //是否是视频
  const [isVideo, setIsVideo] = useState<boolean>(false);
  const [link, setLink] = useState<string>();
  const [adsId, setAdsId] = useState<number>();
  const videoMaxWidth = getWindowWidth() * 0.9;
  const videoMaxHeight = getWindowHeight() * 0.9;
  const imageMaxWidth = getWindowWidth() * 0.9;
  const imageMaxHeight = getWindowHeight() * 0.9;
  // 视频可视宽度
  const [videoWidth, setVideoWidth] = useState<number>();
  // 图片可视宽度
  const [imageWidth, setImageWidth] = useState<number>();
  const [mediaLoaded, setMediaLoaded] = React.useState<boolean>(false);
  // 禁用跳过按钮
  const [disabledSkip, setDisabledSkip] = React.useState<boolean>(true);

  // 更新广告内容位置
  const updateContentMarginTop = () => {
    if (contentRef.current) {
      contentRef.current.style.marginTop = ((getWindowHeight() - contentRef.current.clientHeight) / 2) + 'px';
    }
  };

  useEffect(() => {
    if (mediaLoaded) {
      // 更新广告内容位置
      updateContentMarginTop();

      // 浏览器大小变化时，更新广告内容位置
      window.addEventListener('resize', () => {
        updateContentMarginTop();
      });

      // 如果后台没有配置多久启用跳过按钮，默认3秒后启用跳过按钮
      setTimeout(() => {
        setDisabledSkip(false);
      }, skipAdsSeconds ? skipAdsSeconds * 1000 : 3000);

      // 如果后台配置了显示多久广告，就在后台配置的时间后关闭广，单位：秒
      if (showAdsSeconds) {
        setTimeout(() => {
          onClose();
        }, showAdsSeconds * 1000);
      }
    }
  }, [mediaLoaded]);

  /** 保存广告观看日志 */
  useEffect(() => {
    if (adsId) {
      addFoodifoxLog('foxH5Ads/saveAdsViewLog', {
        deviceCode,
        phoneNumber,
        adId: adsId,
      });
    }
  }, [adsId]);

  useEffect(() => {
    const { adId, link, mediaList } = adsList[getRandomIntInRange(0, adsList.length - 1)];
    if (adId) {
      setAdsId(adId);
    }
    if (mediaList) {
      const ads = mediaList[getRandomIntInRange(0, mediaList.length - 1)];
      setIsVideo(ads.mediaType === 'mp4');
      setMediaUrl(ads.mediaUrl);
    }
    if (link) {
      setLink(link);
    }
  }, []);

  return (
    <Modal
      style={{ width: '100vw', height: '100vh', minWidth: '100vw', padding: 'unset', backgroundColor: 'unset', boxShadow: 'unset', margin: 'unset' }}
    >
      {
        !mediaLoaded && (
          <ColumnCenter ref={contentRef} style={{ height: '100vh' }}>
            <Loading />
          </ColumnCenter>
        )
      }
      <ColumnCenter ref={contentRef} style={{ opacity: mediaLoaded ? 1 : 0, height: mediaLoaded ? '100vh' : 0 }}>
        {
          isVideo ? (
            <video
              muted
              loop
              autoPlay
              playsInline
              style={{
                width: videoMaxWidth,
                maxWidth: videoMaxWidth,
                minWidth: videoMaxWidth,
                borderRadius: 14,
                // 最大高度限制和 object-fit 属性
                maxHeight: videoMaxHeight,
                objectFit: 'contain',
              }}
              onClick={() => {
                if (adsId) {
                  try {
                    addFoodifoxLog('foxH5Ads/saveAdsClickLog', {
                      deviceCode,
                      phoneNumber,
                      adId: adsId,
                    });
                  } catch (e) {

                  }
                }
                if (link && /^(http|https):\/\//.test(link)) {
                  window.open(link, '_blank');
                }
              }}
              onLoadedMetadata={(e) => {
                const video = e.target as HTMLVideoElement;
                // 使用更可靠的尺寸计算方法
                const containerRatio = video.clientWidth / video.clientHeight;
                const videoRatio = video.videoWidth / video.videoHeight;

                let displayWidth;
                if (containerRatio > videoRatio) {
                  // 容器更宽，视频高度受限
                  displayWidth = video.clientHeight * videoRatio;
                } else {
                  // 容器更高，视频宽度受限
                  displayWidth = video.clientWidth;
                }

                setVideoWidth(displayWidth);
                setMediaLoaded(true);
              }}
            >
              <source
                src={mediaUrl}
                type="video/mp4"
              />
            </video>
          ) : (
            <img
              src={mediaUrl}
              alt="ads"
              style={{
                width: imageMaxWidth,
                maxWidth: imageMaxWidth,
                minWidth: imageMaxWidth,
                borderRadius: 14,
                // 最大高度限制和 object-fit 属性
                maxHeight: imageMaxHeight,
                objectFit: 'contain',
              }}
              onLoad={(e) => {
                const img = e.target as HTMLImageElement;
                // 等待一帧确保布局完成
                requestAnimationFrame(() => {
                  // 获取图片的实际显示尺寸（考虑object-fit和容器限制）
                  const displayWidth = Math.min(
                    img.naturalWidth * (img.clientHeight / img.naturalHeight),
                    img.clientWidth
                  );
                  setImageWidth(displayWidth);
                  setMediaLoaded(true);
                });
              }}
              onClick={() => {
                if (adsId) {
                  try {
                    addFoodifoxLog('foxH5Ads/saveAdsClickLog', {
                      deviceCode,
                      phoneNumber,
                      adId: adsId,
                    });
                  } catch (e) {

                  }
                }
                if (link && /^(http|https):\/\//.test(link)) {
                  window.open(link, '_blank');
                }
              }}
            />
          )
        }
        <RowEnd style={{ width: isVideo ? videoWidth : imageWidth }}>
          {/* Okay按钮 */}
          <OkeyBtn onClick={() => onClose()} style={{ marginTop: -38 - 15, marginRight: 10, position: 'absolute' }} disabled={disabledSkip}>
            <SquadBoldText color={'#FFFFFF'}>
              Skip Ad
            </SquadBoldText>
          </OkeyBtn>
        </RowEnd>
      </ColumnCenter>
    </Modal>
  );
};

export interface Props {
  onClose: () => void;
  isEnglish: boolean;
  adsList: Ads3pdVO[];
  showAdsSeconds: number;
  deviceCode: string;
  phoneNumber?: number;
  skipAdsSeconds: number;
}

export default AdsModal;
